import React, { forwardRef } from "react"
import type { LucideProps } from "lucide-react"

export const FilesIconActive = forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      size = 24,
      color = "currentColor",
      strokeWidth = 1.8,
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        {...props}
      >
        <path
          key="files-outline"
          d="M20 7H17C16.469 7 15.961 6.789 15.586 6.414C15.211 6.039 15 5.531 15 5V2M3 7.6V20.4C3 20.824 3.169 21.231 3.468 21.531C3.768 21.831 4.176 22 4.6 22H14.4M9 18C8.469 18 7.961 17.789 7.586 17.414C7.211 17.039 7 16.531 7 16V4C7 3.469 7.211 2.961 7.586 2.586C7.961 2.211 8.469 2 9 2H16L20 6V16C20 16.531 19.789 17.039 19.414 17.414C19.039 17.789 18.531 18 18 18H9Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          key="files-fill"
          d="M7.2 2.4H14.4V4.8L15 6L16.8 7.2L19.8 7.8V17.4H7.2V2.4Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)

FilesIconActive.displayName = "FilesIconActive"
